import api from "@/services/api";

/**
 * @description Servicio para interactuar con el endpoint /plans.
 * Gestiona el CRUD de planes de cobertura (Prepaga, Obra Social, PMO, Complementario).
 */
const planService = {};

const endpoint = "/plans";

/**
 * @description Obtiene listado paginado de planes con filtros
 * @param {Object} params - Parámetros de búsqueda
 * @param {string} [params.searchInput] - Texto de búsqueda (código, nombre)
 * @param {string} [params.type] - Filtrar por tipo (prepaid, social, pmo, complementary)
 * @param {string} [params.status] - Filtrar por estado (active, inactive)
 * @param {number} [params.offset] - Offset para paginación
 * @param {number} [params.limit] - Límite de resultados
 * @returns {Promise<{docs: Array, total: number}>} Resultado paginado
 */
planService.query = function (params) {
  return api.get(endpoint, { params }).then((res) => res.data);
};

/**
 * @description Obtiene un plan por su ID
 * @param {string} id - ID del plan
 * @returns {Promise<Object>} Datos del plan
 */
planService.getById = function (id) {
  return api.get(`${endpoint}/${id}`).then((res) => res.data);
};

/**
 * @description Crea un nuevo plan
 * @param {Object} data - Datos del plan
 * @param {string} data.code - Código del plan
 * @param {string} data.name - Nombre
 * @param {string} data.type - Tipo (prepaid, social, pmo, complementary)
 * @param {string} [data.description] - Descripción
 * @param {number} [data.monthlyFee] - Cuota mensual
 * @param {string} [data.status] - Estado
 * @returns {Promise<Object>} Plan creado
 */
planService.create = function (data) {
  return api.post(endpoint, data).then((res) => res.data);
};

/**
 * @description Actualiza un plan existente
 * @param {string} id - ID del plan
 * @param {Object} data - Campos a actualizar
 * @returns {Promise<Object>} Plan actualizado
 */
planService.update = function (id, data) {
  return api.put(`${endpoint}/${id}`, data).then((res) => res.data);
};

/**
 * @description Elimina un plan
 * @param {string} id - ID del plan
 * @returns {Promise<void>}
 */
planService.remove = function (id) {
  return api.delete(`${endpoint}/${id}`);
};

export default planService;
